export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13076.c3d9b7d1.jpg";